import { render, staticRenderFns } from "./SupplyPage.vue?vue&type=template&id=d01222a4&scoped=true&lang=pug&"
import script from "./SupplyPage.vue?vue&type=script&lang=js&"
export * from "./SupplyPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplyPage.vue?vue&type=style&index=0&id=d01222a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01222a4",
  null
  
)

export default component.exports